const TicketJourneyTypes = {
	Single: 1,
	Return: 2,
	Circular: 3,
	Ranger: 4
};

const getLabel = value => {
	switch (value) {
		case TicketJourneyTypes.Single:
			return "Single";
		case TicketJourneyTypes.Return:
			return "Return";
		case TicketJourneyTypes.Circular:
			return "Circular";
		case TicketJourneyTypes.Ranger:
			return "Ranger";
		default:
			return "Unknown";
	}
};

export default TicketJourneyTypes;
export {TicketJourneyTypes as values, getLabel};
